<template>
  <div :class="`sub-group-option-cont${!!SubscriptionGroupData.selected ? ' selected':''}`"
       @click="toggleOption">
    <div>{{ SubscriptionGroupData.name }}</div>
    <div v-if="loading">
      <v-progress-circular indeterminate :size="16" :width="2"></v-progress-circular>
    </div>
    <div v-else>
      <v-icon
          :color="!!SubscriptionGroupData.selected ? '#47BD96FF':'#FFFFFF26'"
          small
      >
        {{ !!SubscriptionGroupData.selected ? 'fas fa-check-square' : 'far fa-square' }}
      </v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionGroupOption',
  props: {
    SubscriptionGroupData: {
      type: Object,
      default: () => ({name: '', selected: false}),
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleOption() {
      this.$emit('toggle');
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-group-option-cont {
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-column-gap: 12px;
  border-left: 1px solid;
  border-color: #47BD96FF;
  padding-left: 12px;
  transition: all ease-in-out 0.2s;
  background-image: none;
  justify-content: center;
  align-items: center;
  opacity: 0.5;
  cursor: pointer;

  &.selected {
    border-color: #8260b9;
    border-width: 2px;
    opacity: 1;
  }

  &:hover {
    text-shadow: 0 0 3px #1B6E5A;
    //background-image: radial-gradient(circle, rgba(130, 96, 185, 0.1) 10%, transparent 80%);
    opacity: 0.7;
  }
}
</style>